import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const ButtonMailto = ({ mailto, label }) => {
    return (
        <NavLinks
            to='#'
            onClick={(e) => {
                window.location = mailto;
                e.preventDefault();
            }}
        >
            {label}
        </NavLinks>
    );
};

const NavLinks = styled(Link)`
    text-decoration: none;
    color: #fff;
    background: #292929;
    padding: 5px 20px;
    border: 2px solid #454545;
    border-radius: 30px;
    font-weight: 700;
    cursor: pointer;
    letter-spacing: 1px;

    &:hover{
        background: #454545;
    }
`;


export default ButtonMailto;